import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SessionStorage from 'libs/SessionStorage';
import Account from 'modules/Account';
import { getLoader } from '../helpers';
function action({ route, query, store }) {
    if (process.env.BROWSER) {
        if (query.returnPathname) {
            SessionStorage.setItem('returnPathname', query.returnPathname);
        }
        store.dispatch(Account.actions.authCallback(query.code));
    }
    const Loader = getLoader(store);
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        // redirect,
        component: /*#__PURE__*/ _jsx(Loader, {})
    };
}
export default action;
